import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_plugin_7fdcac64 from 'nuxt_plugin_plugin_7fdcac64' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_7d56c640 from 'nuxt_plugin_plugin_7d56c640' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_plugin_98d1df94 from 'nuxt_plugin_plugin_98d1df94' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_distplugind0e3a94c_54653dc2 from 'nuxt_plugin_distplugind0e3a94c_54653dc2' // Source: ./dist.plugin.d0e3a94c.mjs (mode: 'all')
import nuxt_plugin_vsanitize_65b0b3d4 from 'nuxt_plugin_vsanitize_65b0b3d4' // Source: ./v-sanitize.js (mode: 'all')
import nuxt_plugin_pluginutils_677f58d7 from 'nuxt_plugin_pluginutils_677f58d7' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_3b0d0c62 from 'nuxt_plugin_pluginrouting_3b0d0c62' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_2db7eb66 from 'nuxt_plugin_pluginmain_2db7eb66' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_storage_b4152602 from 'nuxt_plugin_storage_b4152602' // Source: ./storage.js (mode: 'all')
import nuxt_plugin_workbox_594b2600 from 'nuxt_plugin_workbox_594b2600' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_6fc325da from 'nuxt_plugin_metaplugin_6fc325da' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_6673daf2 from 'nuxt_plugin_iconplugin_6673daf2' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_axios_610ccc38 from 'nuxt_plugin_axios_610ccc38' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_image_8afed242 from 'nuxt_plugin_image_8afed242' // Source: ./image.js (mode: 'all')
import nuxt_plugin_hubbleclients_67f31bc0 from 'nuxt_plugin_hubbleclients_67f31bc0' // Source: ../plugins/hubble-clients.js (mode: 'all')
import nuxt_plugin_preview_f040bdb6 from 'nuxt_plugin_preview_f040bdb6' // Source: ../plugins/preview.js (mode: 'all')
import nuxt_plugin_fontawesome_b8db358e from 'nuxt_plugin_fontawesome_b8db358e' // Source: ../plugins/fontawesome.js (mode: 'all')
import nuxt_plugin_axios_5659d192 from 'nuxt_plugin_axios_5659d192' // Source: ../plugins/axios.js (mode: 'all')
import nuxt_plugin_meta_655cfe70 from 'nuxt_plugin_meta_655cfe70' // Source: ./composition-api/meta.mjs (mode: 'all')
import nuxt_plugin_layoutdata_831ac940 from 'nuxt_plugin_layoutdata_831ac940' // Source: ../plugins/layout-data.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const store = null
  const router = await createRouter(ssrContext, config, { store })

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"lang":"da","title":"Telmore Shop","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""},{"name":"format-detection","content":"telephone=no"},{"name":"msapplication-TileColor","content":"#ffcae3"},{"name":"theme-color","content":"#ffcae3"}],"link":[{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Fapple-touch-icon.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicon-16x16.png"},{"rel":"mask-icon","href":"\u002Fsafari-pinned-tab.svg","color":"#002788"}],"script":[{"src":"cookie-consent.js","type":"text\u002Fjavascript","external":false,"id":"google-cookie-consent"},{"src":"https:\u002F\u002Fpolicy.app.cookieinformation.com\u002Fuc.js","type":"text\u002Fjavascript","external":true,"async":true,"defer":true,"id":"CookieConsent","data-culture":"DA","data-gcm-version":"2.0"},{"src":"\u002F\u002Fassets.adobedtm.com\u002F0925f9fe4554\u002F5a316aa8842a\u002Flaunch-284b8a2b5913.min.js","type":"text\u002Fjavascript","external":true,"async":true,"defer":true,"id":"adobe-analytics"},{"src":"\u002F\u002Ftag.heylink.com\u002Fe074b709-341d-4489-b3db-1c53e26f0625\u002Fscript.js","type":"text\u002Fjavascript","external":true,"defer":true,"id":"heylink"}],"style":[]},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_7fdcac64 === 'function') {
    await nuxt_plugin_plugin_7fdcac64(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_7d56c640 === 'function') {
    await nuxt_plugin_plugin_7d56c640(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_98d1df94 === 'function') {
    await nuxt_plugin_plugin_98d1df94(app.context, inject)
  }

  if (typeof nuxt_plugin_distplugind0e3a94c_54653dc2 === 'function') {
    await nuxt_plugin_distplugind0e3a94c_54653dc2(app.context, inject)
  }

  if (typeof nuxt_plugin_vsanitize_65b0b3d4 === 'function') {
    await nuxt_plugin_vsanitize_65b0b3d4(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_677f58d7 === 'function') {
    await nuxt_plugin_pluginutils_677f58d7(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_3b0d0c62 === 'function') {
    await nuxt_plugin_pluginrouting_3b0d0c62(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_2db7eb66 === 'function') {
    await nuxt_plugin_pluginmain_2db7eb66(app.context, inject)
  }

  if (typeof nuxt_plugin_storage_b4152602 === 'function') {
    await nuxt_plugin_storage_b4152602(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_594b2600 === 'function') {
    await nuxt_plugin_workbox_594b2600(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_6fc325da === 'function') {
    await nuxt_plugin_metaplugin_6fc325da(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_6673daf2 === 'function') {
    await nuxt_plugin_iconplugin_6673daf2(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_610ccc38 === 'function') {
    await nuxt_plugin_axios_610ccc38(app.context, inject)
  }

  if (typeof nuxt_plugin_image_8afed242 === 'function') {
    await nuxt_plugin_image_8afed242(app.context, inject)
  }

  if (typeof nuxt_plugin_hubbleclients_67f31bc0 === 'function') {
    await nuxt_plugin_hubbleclients_67f31bc0(app.context, inject)
  }

  if (typeof nuxt_plugin_preview_f040bdb6 === 'function') {
    await nuxt_plugin_preview_f040bdb6(app.context, inject)
  }

  if (typeof nuxt_plugin_fontawesome_b8db358e === 'function') {
    await nuxt_plugin_fontawesome_b8db358e(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5659d192 === 'function') {
    await nuxt_plugin_axios_5659d192(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_655cfe70 === 'function') {
    await nuxt_plugin_meta_655cfe70(app.context, inject)
  }

  if (typeof nuxt_plugin_layoutdata_831ac940 === 'function') {
    await nuxt_plugin_layoutdata_831ac940(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
